class nextDayDeliveryCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.countdownTimer();
  }

  countdownTimer() {
    // Set the date we're counting down to
    const now = new Date();
    const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)
    const currentTime = now.getHours() + ":" + now.getMinutes();
    const cutoffTime = this.getAttribute('data-delivery-cutoff-time');
    
    let countDownDate;
    let bankHolidays;
    let today;
    let useBankHolidays;

    // Get stored bank holidays
    if (this.getAttribute('data-delivery-bank-holiday-cutoff-dates').length > 0) {
        bankHolidays = this.getAttribute('data-delivery-bank-holiday-cutoff-dates').split(',').map(date => {
          let [day, month, year] = date.split('/');
          // Remove leading '0' from day and month
          day = day.startsWith('0') ? day.slice(1) : day;
          month = month.startsWith('0') ? month.slice(1) : month;
          // Return new value
          return `${month}/${day}/${year}`;
      });
      today = (now.getMonth() + 1) + '/' + now.getDate() + '/' + (now.getFullYear().toString().substr(-2));

      useBankHolidays = true;
    }

    if (useBankHolidays == true && bankHolidays.includes(today)) {
        // If today is a bank holiday, hide the standard message and hide the timer.
        document.querySelector('.js-product-delivery-message').style.display = 'none';
        this.style.display = 'none';
    } else if (dayOfWeek >= 1 && dayOfWeek <= 4 && currentTime < cutoffTime) {
        // If it's NOT a bank holiday and the week day is Monday to Thursday and the current time is before the cutoff time, set countdown to next day and hide standard message.
        now.setDate(now.getDate());
        const targetTime = cutoffTime.split(':');
        countDownDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), targetTime[0], targetTime[1]).getTime();
        const nextDay = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][now.getDay()];
        if (nextDay) {
            document.getElementById("next-available-weekday").innerHTML = nextDay;
        } else {
            document.querySelector('.js-product-delivery-message').style.display = 'block';
            this.style.display = 'none';
        }
    } else if (dayOfWeek >= 1 && dayOfWeek <= 4 && currentTime >= cutoffTime) {
        // If it's NOT a bank holiday and the week day is Monday to Thursday and the current time is after the cutoff time, set countdown to day after next and hide standard message.
        now.setDate(now.getDate() + 1);
        const targetTime = cutoffTime.split(':');
        countDownDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), targetTime[0], targetTime[1]).getTime();
        const nextDay = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"][now.getDay()];

        if (nextDay) {
            document.getElementById("next-available-weekday").innerHTML = nextDay;
        } else {
            document.querySelector('.js-product-delivery-message').style.display = 'block';
            this.style.display = 'none';
        }
    } else if (dayOfWeek >= 5) {
        // If it's NOT a bank holiday and the week day is Friday, Saturday or Sunday, display the standard message and hide the timer.
        document.querySelector('.js-product-delivery-message').style.display = 'block';
        this.style.display = 'none';
    }

    // Update the count down every 1 second
    const countdownfunction = setInterval(function() {
      // Get today's date and time
      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update the countdown display
      let countdownDisplay = "";
      if (days > 0) countdownDisplay += days + "d ";
      if (hours > 0) countdownDisplay += hours + "h ";
      if (minutes > 0) countdownDisplay += minutes + "m ";
      if (seconds > 0) countdownDisplay += seconds + "s ";
      
      // Check if all values have reached 0
      if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
        // If all values are 0, display '.js-product-delivery-message' and hide 'nextday-delivery-countdown-component'
        document.querySelector('.js-product-delivery-message').style.display = 'block';
        document.querySelector('nextday-delivery-countdown-component').style.display = 'none';
      } else {
        // If not all values are 0, update the countdown display
        document.getElementById("countdown").innerHTML = countdownDisplay;
      }

    }, 1000);
  }
}

customElements.define('nextday-delivery-countdown-component', nextDayDeliveryCountdown);
